import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import { fetchVocabularies, updateVocabulariesFilter } from '../actions';

const VocabulariesFilters = ({
  category,
  filterTerm,
  updateFilterTerm,
  fetchData,
  readErrors,
  className,
  fluid,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-vocabularies-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, 1, null, false)}
  />
);

const mapStateToProps = ({
  vocabularies: { vocabularies },
}, { category }) => {
  const { filter, readErrors } = vocabularies[category];
  return ({ filterTerm: filter, readErrors });
};

const mapDispatchToProps = {
  updateFilterTerm: updateVocabulariesFilter,
  fetchData: fetchVocabularies,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabulariesFilters);
